import simpleLoading from 'simple-loading'
import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-import-form', {
  mixins: [eventListenerMixin],
  properties: {
    redirectTo: {
      type: String,
    },
  },

  ready() {
    this.spreadsheet = this.querySelector('tr-spreadsheet');
    this.realSubmit = this.querySelector('input[type=submit]');
    this.submitBtn = document.querySelector('#import-btn');
    this.successDialog = document.querySelector('.success-dialog');

    this.listenTo(this.submitBtn, 'click', () => {
      this.realSubmit.click();
    });
    this.listenTo(this.successDialog, 'tao:closed', () => {
      if (this.redirectTo) window.location.replace(this.redirectTo);
    });
    $(this).on('ajax:beforeSend', this.handleBeforeSend);
    $(this).on('ajax:complete', this.handleComplete);
  },

  handleComplete() {
    this.submitBtn.removeAttribute('disabled');
  },

  handleBeforeSend() {
    this.loading = simpleLoading({
      type: 'global',
      msg: '正在准备导入数据',
    });
    this.submitBtn.setAttribute('disabled', true);
  },

  showErrors(errors) {
    this.spreadsheet.showErrors(errors);
  },

  disconnected() {
    this.stopListening();
  },
});
